"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _react = _interopRequireWildcard(require("react"));

var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));

var _reactRouter = require("react-router");

var _mmcVehicleCodeUtility = _interopRequireWildcard(require("@mmc-tools/mmc-vehicle-code-utility"));

var _tableCompare = _interopRequireDefault(require("../styles/table-compare.css"));

var _tableCompare2 = _interopRequireDefault(require("./table-compare.props/table-compare.defaultProps"));

var _tableCompare3 = require("./table-compare.props/table-compare.propTypes");

var _carSelectorContainer = _interopRequireDefault(require("./containers/car-selector-container"));

var _modelSelectorContainer = _interopRequireDefault(require("./containers/model-selector-container"));

var _comparisonTableContainer = _interopRequireDefault(require("./containers/comparison-table-container"));

var _comparisonBannerContainer = _interopRequireDefault(require("./containers/comparison-banner-container"));

var _actionTypes = require("../redux/actions/action-types");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var ObfuscateVehicleCode = new _mmcVehicleCodeUtility["default"](_mmcVehicleCodeUtility.VEHICLES_MAP);
var getVehicleByCode = ObfuscateVehicleCode.getVehicleByCode,
    getVehicleByGuid = ObfuscateVehicleCode.getVehicleByGuid;
var dataUtils = new _mmcDataUtilities["default"]();
var shouldUseDataOrDefaultProps = dataUtils.shouldUseDataOrDefaultProps;

var TableCompare = /*#__PURE__*/function (_React$Component) {
  (0, _inheritsLoose2["default"])(TableCompare, _React$Component);

  TableCompare.resourceType = function resourceType() {
    return 'CompareSection_1_0_0';
  };

  function TableCompare(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.numberOfColumns = 2;
    _this.flipVisibility = _this.flipVisibility.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  var _proto = TableCompare.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var _this$props = this.props,
        _this$props$location = _this$props.location,
        location = _this$props$location === void 0 ? {} : _this$props$location,
        dispatch = _this$props.dispatch;

    if (location.query && location.query.vehicle) {
      dispatch({
        type: _actionTypes.SELECT_VEHICLE,
        vehicle: {
          code: getVehicleByGuid(location.query.vehicle),
          year: location.query.year
        }
      });
    }
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    // check for screensize
    if (typeof window !== 'undefined') {
      var width = window.innerWidth || -1;
      var lowerBreakpoint = 50;
      var upperBreakpoint = 768;
      if (width > lowerBreakpoint) this.numberOfColumns = 2;
      if (width > upperBreakpoint) this.numberOfColumns = 3;
    }
  };

  _proto.getVehicles = function getVehicles(componentData) {
    var currentPath = this.props.currentPath;
    var vehicles = componentData.carSelector.productTile;
    return vehicles.map(function (vehicle) {
      return _objectSpread(_objectSpread({}, vehicle), {}, {
        cta: {
          url: currentPath + "?vehicle=" + getVehicleByCode(vehicle.code) + "&year=" + vehicle.year
        }
      });
    });
  };

  _proto.flipVisibility = function flipVisibility() {
    var dispatch = this.props.dispatch;
    dispatch({
      type: _actionTypes.DESELECT_VEHICLE
    });
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        data = _this$props2.data,
        theme = _this$props2.theme,
        defaultData = _this$props2.defaultData,
        path = _this$props2.path,
        currentPath = _this$props2.currentPath,
        nextSteps = _this$props2.nextSteps;
    var componentData = shouldUseDataOrDefaultProps(data, defaultData);
    var vehicles = this.getVehicles(componentData);
    var numberOfColumns = this.numberOfColumns;
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
      className: "" + (nextSteps.modelCompare ? _tableCompare["default"].hidden : '')
    }, /*#__PURE__*/_react["default"].createElement(_carSelectorContainer["default"], {
      vehicles: vehicles,
      theme: theme
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: theme['container-fluid'] + " " + _tableCompare["default"].noPadding + " " + (nextSteps.modelCompare ? '' : _tableCompare["default"].hidden)
    }, /*#__PURE__*/_react["default"].createElement(_comparisonBannerContainer["default"], {
      vehicles: vehicles,
      theme: theme,
      steps: data.steps,
      switchView: this.flipVisibility,
      resetPath: currentPath
    }), /*#__PURE__*/_react["default"].createElement(_modelSelectorContainer["default"], {
      theme: theme,
      path: path,
      vehicles: vehicles,
      currentPath: currentPath,
      numberOfColumns: numberOfColumns
    }), /*#__PURE__*/_react["default"].createElement(_comparisonTableContainer["default"], {
      vehicles: vehicles,
      theme: theme,
      numberOfColumns: numberOfColumns
    })));
  };

  return TableCompare;
}(_react["default"].Component);

TableCompare.displayName = 'TableCompare';
TableCompare.defaultProps = {
  data: _tableCompare2["default"],
  defaultData: _tableCompare2["default"]
};

var _default = (0, _reactRouter.withRouter)(TableCompare);

exports["default"] = _default;